import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { ExpiredClockIcon } from 'v2/icons';
import { SearchEntity } from 'v2/models';
import styles from 'v2/common/ExtendedRequest/extendedRequestTooltip.module.scss';
import { getIsSearchRenewable } from 'v2/pages/SearchDetails/BottomButtons/useRenewSearch';

interface IExpiredTooltipProps
  extends Pick<SearchEntity, 'expires_at' | 'free' | 'id'> {
  detail?: boolean;
}

const LIST_TEXT =
  'Your Request has expired. Click into the Request details to renew.';
const DETAIL_TEXT =
  'Your Request has expired. Click the Renew Request button below if you would like to keep searching for this data.';

export const ExpiredTooltip = ({
  detail,
  expires_at,
  free,
}: IExpiredTooltipProps) => {
  const isExpired = getIsSearchRenewable({ expires_at, free });

  const text = detail ? DETAIL_TEXT : LIST_TEXT;

  if (!isExpired) {
    return null;
  }

  return (
    <div className="mr-2">
      <OverlayTrigger
        placement={'top'}
        overlay={
          <Popover id={'expired-search-pop'} className={styles.popover}>
            <Popover.Content className={styles.popoverBody}>
              {text}
            </Popover.Content>
          </Popover>
        }
      >
        <div className="d-inline-block">
          <ExpiredClockIcon />
        </div>
      </OverlayTrigger>
    </div>
  );
};
